<template>
    <div>
        <button alt="left" aria-label="left" class="carousel-control left bot" @click="$emit('prev')"><img src="/wp-content/uploads/2024/10/449353309_785657433420175_7340031632161029158_n-removebg-preview-1.png" alt=""></button>
        <button alt="right" aria-label="right" class="carousel-control right bot" @click="$emit('next')"><img src="/wp-content/uploads/2024/10/449353309_785657433420175_7340031632161029158_n-removebg-preview-1.png" alt=""></button>
        <button alt="left" aria-label="left" class="carousel-control left top" @click="$emit('prev')"><img src="/wp-content/uploads/2024/10/449353309_785657433420175_7340031632161029158_n-removebg-preview-1.png" alt=""></button>
        <button alt="right" aria-label="right" class="carousel-control right top" @click="$emit('next')"><img src="/wp-content/uploads/2024/10/449353309_785657433420175_7340031632161029158_n-removebg-preview-1.png" alt=""></button>
    </div>
</template>
<script>

export default{
    emits: ['prev','next']
}
</script>

<style>
    .carousel-control{
        border:none;
        background: transparent;
        display: inline-block;
        position: absolute;
        height: 50px;
        width: 70px;
        top: calc(50% - 25px);
        cursor: pointer;
    }
    svg{
        width:20px;
        filter: invert(100%) sepia(5%) saturate(7463%) hue-rotate(225deg) brightness(108%) contrast(101%);
    }
    .left{
        left:0;
    }
    .right{
        right: 0;
    }
</style>